import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/ContactBookIllustration.tsx
const ContactBookIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "contact-book.svg",
		alt: t("illustration.imageAlt.contactBook")
	});
};

//#endregion
export { ContactBookIllustration };